import { lazy } from "react";

const menu = [
  {
    path: '/',
    exact: true,
    component: lazy(() => import('../../../pages/Profile'))
  }
]

export { menu };